export default __webpack_public_path__ + "static/media/display_half.66ef3a71.svg";